import { render, staticRenderFns } from "./My-Form-mob.vue?vue&type=template&id=4b8a55e9&scoped=true"
import script from "./My-Form-mob.vue?vue&type=script&lang=js"
export * from "./My-Form-mob.vue?vue&type=script&lang=js"
import style0 from "./My-Form-mob.vue?vue&type=style&index=0&id=4b8a55e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a55e9",
  null
  
)

export default component.exports